import { createStore } from 'vuex'


import { alert } from './alert.module'
import { authentication } from './authentication.module'
import { users } from './users.module'
import { admin } from './admin.module'
import { student } from './student.module'
import { mentor } from './mentor.module'
import { review } from './review.module'


export const store = createStore({
    modules: {
        alert,
        authentication,
        users,
        admin,
        student,
        mentor,
        review
    }
})
